<template>
  <div
    class="relative flex items-center justify-center overflow-hidden bg-light-gray"
    :class="{
      'h-240px': layoutStore.isDesktop,
      'h-160px': layoutStore.isMobile,
    }"
  >
    <div v-if="layoutStore.isMobile" class="pointer-events-none opacity-40">
      <ArtistsBannerImage
        v-if="artistImageList.length !== 0"
        class="absolute right-75% -top-30%"
        :column="5"
        :column-gap="20"
        :image-size="30"
        :images="artistImageList"
        :rotate="-45"
        :row="4"
        :row-gap="20"
      />
      <ArtistsBannerImage
        v-if="artistImageList.length !== 0"
        class="absolute left-75% -bottom-30%"
        :column="5"
        :column-gap="20"
        :image-size="30"
        :images="artistImageList"
        :rotate="-45"
        :row="4"
        :row-gap="20"
      />
    </div>
    <div v-else class="pointer-events-none opacity-80">
      <ArtistsBannerImage
        v-if="artistImageList.length !== 0"
        class="absolute right-70% -top-80px"
        :column="5"
        :column-gap="60"
        :image-size="60"
        :images="artistImageList"
        :rotate="-8"
        :row="4"
        :row-gap="30"
      />
      <ArtistsBannerImage
        v-if="artistImageList.length !== 0"
        class="absolute left-70% -top-80px"
        :column="5"
        :column-gap="60"
        :image-size="60"
        :images="artistImageList"
        :rotate="-8"
        :row="4"
        :row-gap="30"
      />
    </div>
    <div class="absolute">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useQuery } from 'villus'
import { onMounted, ref } from 'vue'

import { ArtistsForCarouselDocument } from '@/graphql/creator-platform/generated'
import { backendLocation } from '@/graphql/utils'
import { useLayoutStore } from '@/store/layoutStore'

import ArtistsBannerImage from './ArtistsBannerImage.vue'

const layoutStore = useLayoutStore()

const artistImageList = ref<string[]>([])

onMounted(async () => {
  await queryArtists()
})

async function queryArtists(): Promise<void> {
  const { data, error } = await useQuery({
    query: ArtistsForCarouselDocument,
    variables: {
      location: backendLocation,
    },
  })
  if (data.value === null || error.value !== null) {
    return
  }
  const list: string[] = []
  for (const { avatar } of data.value.artistsForDittoCarousel) {
    if (typeof avatar === 'string') {
      list.push(avatar)
    }
  }
  artistImageList.value = list
}
</script>
